export default "https://cdn-static-staging.gokick.com/assets/98f5e78fc13494034d6569c4b787741d65d3002e/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";